module.exports = __webpack_public_path__ + "img/pic_bioland@2x.67417f02.png";